import {
  FETCH_PRIVACY_SETTINGS_REQUEST,
  FETCH_PRIVACY_SETTINGS_SUCCESS,
  FETCH_PRIVACY_SETTINGS_FAILURE,
} from "./types";

// Service import
import { fetchPrivacySettings } from "../../services/privacySettingsService";

// Action Creators
export const fetchPrivacySettingsRequest = () => ({ type: FETCH_PRIVACY_SETTINGS_REQUEST });
export const fetchPrivacySettingsSuccess = (settings) => ({
  type: FETCH_PRIVACY_SETTINGS_SUCCESS,
  payload: settings,
});
export const fetchPrivacySettingsFailure = (error) => ({
  type: FETCH_PRIVACY_SETTINGS_FAILURE,
  payload: error,
});

// Thunk to fetch privacy settings
export const fetchPrivacySettingsAction = () => async (dispatch) => {
  dispatch(fetchPrivacySettingsRequest());
  try {
    const response = await fetchPrivacySettings();
    if (response.success) {
      dispatch(fetchPrivacySettingsSuccess(response.data));
    } else {
      dispatch(fetchPrivacySettingsFailure(response.error));
    }
  } catch (error) {
    dispatch(fetchPrivacySettingsFailure(error.message || "Failed to fetch privacy settings"));
  }
};
